import { request, type DataInfoResponse, type PagedList } from './request';
import { buildListParams } from './params';
import type { HospitalDto } from './types';

export interface HospitalListOptions {
  pageIndex?: number;
  pageSize?: number;
  /** 医院名称搜索 */
  name?: string;
}

/** 医院列表（/hospital/userGetHospitalList，公开接口） */
export function fetchHospitalList(options: HospitalListOptions = {}): Promise<PagedList<HospitalDto>> {
  const { pageIndex = 1, pageSize = 10, name = '' } = options;

  return request(
    '/hospital/userGetHospitalList',
    buildListParams({
      pageIndex,
      pageSize,
      state: 1,
      name,
    }),
  );
}

/** 医院详情（/hospital/userGetHospitalInfo，公开接口） */
export function fetchHospitalInfo(id: number): Promise<DataInfoResponse<HospitalDto>> {
  return request('/hospital/userGetHospitalInfo', { id });
}
